module.exports = __webpack_public_path__ + "68af364fd155ac7a50a1dcff4ac14e8c.jpg";